export default (props, vars) => props?.['register'] || {};
